import { ReactNode } from 'react';
import { PageProps } from '@frontend/components';
import { usePhoneSettingsShallowStore } from '@frontend/phone-config';
import { SettingsPage, SettingsPageLayout } from '@frontend/settings-ui';
import { theme } from '@frontend/theme';

export const PhoneSettingsPage = ({
  ribbon,
  title,
  children,
  disableEdit = false,
  renderContainer = true,
  hideLocationChip,
  maxWidth,
  showBackBtn,
  customBackFn,
  ...rest
}: Omit<PageProps<true>, 'isSettingsPage'> & {
  ribbon?: ReactNode;
  disableEdit?: boolean;
  renderContainer?: boolean;
  hideLocationChip?: boolean;
  maxWidth?: number;
}) => {
  const { settingsTenantLocation, openTenantPicker, hasMultipleTenantOptions, tenantLabel } =
    usePhoneSettingsShallowStore(
      'settingsTenantLocation',
      'openTenantPicker',
      'hasMultipleTenantOptions',
      'tenantLabel'
    );

  const settingsLocationConfig = {
    hideLocationChip: !hasMultipleTenantOptions || hideLocationChip,
    isSingleLocation: settingsTenantLocation?.locationType !== 'unify',
    chipLabel: !settingsTenantLocation ? '--' : tenantLabel,
    onActionClick: !disableEdit && hasMultipleTenantOptions ? openTenantPicker : undefined,
  };

  return (
    <SettingsPageLayout css={{ scrollbarGutter: 'stable' }}>
      {ribbon}
      <SettingsPage title={title} settingsLocationConfig={settingsLocationConfig} {...rest}>
        {renderContainer ? (
          <div
            style={{
              background: theme.colors.white,
              padding: theme.spacing(3),
              borderRadius: theme.borderRadius.medium,
              boxShadow: theme.shadows.light,
              maxWidth,
            }}
          >
            {children}
          </div>
        ) : (
          <div style={maxWidth ? { maxWidth } : undefined}>{children}</div>
        )}
      </SettingsPage>
    </SettingsPageLayout>
  );
};
